import { useEffect, useLayoutEffect, useRef } from 'react';

/**
 * Calls `close` when `container` scrolls while `open`, so an overlay anchored
 * inside a scrolling area does not stay floating away from its trigger.
 */
export function useCloseOnScroll(
  container: HTMLElement | null | undefined,
  open: boolean,
  close: () => void,
) {
  const closeRef = useRef(close);
  useLayoutEffect(() => {
    closeRef.current = close;
  });

  useEffect(() => {
    if (!open || !container) return;
    const handleScroll = () => closeRef.current();
    container.addEventListener('scroll', handleScroll, { passive: true });
    return () => container.removeEventListener('scroll', handleScroll);
  }, [container, open]);
}
